export const LINKS = {
  telegramChannel: "https://t.me/trippitravel",
  telegramManager: "https://t.me/trippi_travel",
  instagram: "https://www.instagram.com/trippi.travel?igsh=Z244cXIzY2N2Z3Nt",
  youtube: "https://www.youtube.com/channel/UC8RtVUCxeXOs_0yz4JyMbBg",
  website: "https://trippi-travel.ru",
  email: "trippi.work@gmail.com",
};
